import { useState } from 'react';
import { Button, Form, Row } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { IIncomingKpisFilter } from './IncomingKpis';

interface IIncomingDeferralFilter {
    handleFilter: (params: IIncomingKpisFilter, pageOverride?: number) => void;
    setFilters: React.Dispatch<React.SetStateAction<IIncomingKpisFilter>>;
    filters: IIncomingKpisFilter;
}

export function IncomingKpisFilter({ handleFilter, setFilters, filters }: IIncomingDeferralFilter) {
    const navigate = useNavigate();
    const [inputTypes, setInputTypes] = useState({
        date: 'text',
    });

    function handleTypes(evt: any, type: string) {
        setInputTypes(prev => ({
            ...prev,
            [evt.target.name]: type,
        }));
    }
    function handleChanges(evt: any) {
        let value: any = evt.target.value;
        if (value === 'true') value = true;
        else if (value === 'null') value = false;
        else if (value === 'undefined') value = undefined;

        setFilters({
            ...filters,
            [evt.target.name]: value,
            page: 1,
        });
    }

    return (
        <Form>
            <Row style={{ rowGap: '18px' }}>
                <div className="col-md-4 col-6">
                    <Form.Control
                        placeholder="KPI ID"
                        className="autocomplete-input"
                        name="id"
                        onChange={handleChanges}
                    />
                </div>
                <div className="col-md-4 col-6">
                    <div className="d-flex bg-secondary-o-100 border rounded">
                        <Form.Control
                            placeholder="Date:"
                            className="autocomplete-input border-0 cursor-pointer"
                            type={inputTypes.date}
                            name="date"
                            value={filters?.date || ''}
                            onFocus={e => handleTypes(e, 'date')}
                            onBlur={e => handleTypes(e, 'text')}
                            onChange={handleChanges}
                        />
                        {filters?.date && (
                            <Button
                                variant=""
                                className="py-2 px-3 clearBtn btn-hover-bg-secondary"
                                onClick={() => {
                                    setFilters((prev: any) => ({ ...prev, date: undefined }));
                                }}
                            >
                                <FaTimes fontSize={14} />
                            </Button>
                        )}
                    </div>
                </div>
            </Row>
            <div className="d-flex justify-content-between mt-4">
                <Button onClick={() => handleFilter(filters)}>Search</Button>
                <Button variant="outline-primary" onClick={() => navigate('/controlling/incoming-deferral')}>
                    Incoming Deferral
                </Button>
            </div>
        </Form>
    );
}
